/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";
import { IFolderPecMail, IMailPecMail, ISendMailRequest, IPagedMailsResponse, IPagedMailsRequest } from "../shared/interfaces";




const getMailboxContacts = (aooId: number, uorId: number, mailbox: string, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.get(`PecMail/${aooId}/${uorId}/GetMailboxContacts`, { cancelToken: cancelToken, params: { mailbox: mailbox } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getAllFolders = (aooId: string, uorId: number, mailbox: string, cancelToken?: CancelToken): Promise<IFolderPecMail[]> => {
    return axiosInstance.get(`PecMail/${aooId}/${uorId}/GetAllFolders`, { cancelToken: cancelToken, params: { mailbox: mailbox } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getNotRegisteredMailsInFolderAsStream = (aooId: string, uorId: number, mailbox: string, pagedMailsRequest: IPagedMailsRequest, cancelToken?: CancelToken): Promise<IPagedMailsResponse> => {
    return axiosInstance.post(`PecMail/${aooId}/${uorId}/GetNotRegisteredMailsInFolderAsStream`, pagedMailsRequest, { cancelToken: cancelToken, params: { mailbox: mailbox } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getMailById = (aooId: string, uorId: number, mailbox: string, idMail: string, pdf: boolean, cancelToken?: CancelToken): Promise<any> => {
    let myParams = {
        mailbox,
        idMail,
        pdf
    };
    return axiosInstance.get(`PecMail/${aooId}/${uorId}/GetMailById`, { cancelToken: cancelToken, params: myParams })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getBase64FromUrl = (aooId: number, uorId: number | undefined, mailbox: string, fileUrl: string, cancelToken?: CancelToken): Promise<any> => {
    let myParams = {
        mailbox,
        fileUrl,
        uorId
    };
    return axiosInstance.get(`PecMail/${aooId}/GetBase64FromUrl`, { cancelToken: cancelToken, params: myParams })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const setMailAsRegistered = (aooId: number, uorId: number, mailbox: string, idMail: number, cancelToken?: CancelToken): Promise<any> => {
    let myParams = {
        mailbox,
        idMail
    };
    return axiosInstance.get(`PecMail/${aooId}/${uorId}/SetMailAsRegistered`, { cancelToken: cancelToken, params: myParams })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const sendMail = (aooId: number, uorId: number, mailbox: string, sendMailRequest: ISendMailRequest, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`PecMail/${aooId}/${uorId}/SendMail`, sendMailRequest, { cancelToken: cancelToken, params: { mailbox: mailbox } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getMailAndStatiInvioByPecMailId = (aooId: number, uorId: number | undefined, mailbox: string, pecMailId: number, pdf: boolean, cancelToken?: CancelToken): Promise<IMailPecMail> => {
    let myParams = {
        mailbox,
        pecMailId,
        pdf,
        uorId
    };
    return axiosInstance.get(`PecMail/${aooId}/GetMailAndStatiInvioByPecMailId`, { cancelToken: cancelToken, params: myParams })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


export default {
    getMailboxContacts,
    getAllFolders,
    getNotRegisteredMailsInFolderAsStream,
    getMailById,
    getBase64FromUrl,
    setMailAsRegistered,
    sendMail,
    getMailAndStatiInvioByPecMailId
}